import React, { useEffect } from "react";
import styled from "styled-components";
import Modal from "./Modal";
import { BtnGeneral } from "../../styles/Buttons";
import SearchableSelect from "../Common/SearchableSelect";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const FieldLabel = styled.label`
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  font-family: var(--font-body);
  margin-bottom: 2px;
  display: block;
`;

const FieldWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const Inp = styled.input`
  padding: 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 13px;
  font-family: var(--font-body);
  color: #1e293b;
  outline: none;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    border-color: #007bba;
    box-shadow: 0 0 0 2px rgba(0, 123, 186, 0.12);
  }
`;

const TextArea = styled.textarea`
  padding: 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 12px;
  font-family: var(--font-body);
  color: #1e293b;
  resize: vertical;
  min-height: 60px;
  outline: none;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    border-color: #007bba;
    box-shadow: 0 0 0 2px rgba(0, 123, 186, 0.12);
  }
`;

const selectSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": { borderColor: "#cbd5e1" },
    "&:hover fieldset": { borderColor: "#94a3b8" },
    "&.Mui-focused fieldset": { borderColor: "#007bba" },
  },
  "& .MuiSelect-select": {
    padding: "7px 10px !important",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
  },
};

export default function EnlacesModal({ isOpen, onClose, hook, onSaved }) {
  const {
    titulo, setTitulo,
    tipoId,
    subtipoId, setSubtipoId,
    palabrasClave, setPalabrasClave,
    url, setUrl,
    tiposPadre,
    tiposHijos,
    loadTipos,
    handleTipoChange,
    uploadEnlaces,
    loading,
  } = hook;

  useEffect(() => {
    if (isOpen) loadTipos();
  }, [isOpen]);

  const handleGuardar = async () => {
    const ok = await uploadEnlaces();
    if (ok) {
      if (onSaved) onSaved();
      onClose();
    }
  };

  // Opciones para SearchableSelect
  const opcionesTipo = tiposPadre.map((t) => ({
    value: String(t.id),
    label: t.descripcion,
  }));

  const opcionesSubtipo = tiposHijos.map((h) => ({
    value: String(h.id),
    label: `${h.nombre}${h.detalle ? ` — ${h.detalle}` : ""}`,
  }));

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Cargar Enlace" width="520px">
      <Container>
        {/* TÍTULO */}
        <FieldWrap>
          <FieldLabel>Título *</FieldLabel>
          <Inp
            type="text"
            placeholder="Nombre descriptivo del enlace"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
          />
        </FieldWrap>

        {/* CATEGORÍA */}
        <FieldWrap>
          <FieldLabel>Categoría *</FieldLabel>
          <SearchableSelect
            key={`tipo-${isOpen}`}
            value={tipoId}
            onValueChange={(val) => handleTipoChange(val)}
            options={opcionesTipo}
            multiple={false}
            searchable={true}
            placeholder="Seleccione una categoría..."
            size="small"
            sx={{ width: "100%", ...selectSx }}
          />
        </FieldWrap>

        {/* SUBTIPO */}
        <FieldWrap>
          <FieldLabel>Subtipo *</FieldLabel>
          <SearchableSelect
            key={`subtipo-${tipoId}`}
            value={subtipoId}
            onValueChange={(val) => setSubtipoId(val)}
            options={opcionesSubtipo}
            multiple={false}
            searchable={true}
            placeholder={tipoId ? "Seleccione un subtipo..." : "Seleccione primero una categoría"}
            disabled={!tipoId || opcionesSubtipo.length === 0}
            size="small"
            sx={{ width: "100%", ...selectSx }}
          />
        </FieldWrap>

        {/* URL */}
        <FieldWrap>
          <FieldLabel>URL *</FieldLabel>
          <Inp
            type="url"
            placeholder="https://..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </FieldWrap>

        {/* PALABRAS CLAVE */}
        <FieldWrap>
          <FieldLabel>Palabras clave (separadas por comas)</FieldLabel>
          <TextArea
            placeholder="minsalud, resolución, PBS..."
            value={palabrasClave}
            onChange={(e) => setPalabrasClave(e.target.value)}
          />
        </FieldWrap>

        {/* BOTONES */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", paddingTop: "4px" }}>
          <BtnGeneral bg="gray" onClick={onClose} disabled={loading}>
            Cancelar
          </BtnGeneral>
          <BtnGeneral bg="green" onClick={handleGuardar} disabled={loading}>
            {loading ? "Guardando..." : "Guardar"}
          </BtnGeneral>
        </div>
      </Container>
    </Modal>
  );
}
